import { z } from 'zod';
import { ServiceQuestionsSchema } from './serviceQuestions.js';
/** `businesses/{businessId}/services/{serviceId}` */
export const ServiceSchema = z.object({
    name: z.string().min(1).max(80),
    /** Length in minutes. For an all-day service it is not used to book (the
     *  day's hours are) and holds 480, so a reader that predates `allDay` still
     *  sees a valid, long service. */
    durationMin: z.number().int().min(5).max(480),
    /**
     * Takes the WHOLE working day (doc 45): one booking per resource per day,
     * from that day's opening to its closing — split shifts included — instead
     * of `durationMin` from a chosen start. The assistant offers days, not times.
     */
    allDay: z.boolean().default(false),
    /** The price, or — with `priceMax` — the lowest price of a range ("from"). */
    price: z.number().min(0).max(100000),
    /**
     * Upper end of a price range ("to"), for a service whose final price depends
     * on the job. Absent means one fixed `price`. A value not above `price` is not
     * a range and is read as absent (see {@link servicePriceRange}).
     */
    priceMax: z.number().min(0).max(100000).optional(),
    active: z.boolean().default(true),
    sortOrder: z.number().int().default(0),
    /**
     * Asked before booking, in this order; every one must be answered (doc 64).
     * Absent on services saved before questions existed — read as none.
     */
    questions: ServiceQuestionsSchema.default([]),
});
/**
 * A service's price as `{ from, to }`, `to` null for a fixed price. The ONE
 * reading of `price`/`priceMax`, so the portal, the prompt and the read-back
 * cannot disagree about whether a service has a range.
 */
export function servicePriceRange(s) {
    return { from: s.price, to: s.priceMax != null && s.priceMax > s.price ? s.priceMax : null };
}
export const ServiceWithIdSchema = ServiceSchema.extend({ id: z.string() });
//# sourceMappingURL=service.js.map